module.exports = __webpack_public_path__ + "img/Billiing Info.f689e3ed.svg";